export enum BodyTypes {
  bus = '6055cbbb39b47',
  suv = '6059e88626e1a',
  sedan = '6059e878ac478',
  truckDouble = '60583cc17bf10',
  truckSingle = '60583cb0d05fe',
  cargo = '6055c161a7259',
};